<template>
  <v-dialog v-model="value" persistent>
    <v-card v-if="value && showmap">
      <v-card-text>
        <gmap-address
          class="mt-2"
          :placesinfo="placesinfolabel"
          v-validate="{ required: true }"
          name="ปักหมุดที่อยู่"
          v-model="gmapvalue"
          v-on:input="gmapLocation"
          :lastordercoords="gmapvalue"
          :error="errors.has('ปักหมุดที่อยู่')"
          :shoplocation="shoplocation"
        ></gmap-address>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onCancel" color="grey" outline>
          {{ $t('cancel') }}
        </v-btn>
        <v-btn @click="onSelect" color="primary" depressed>
          {{ $t('Select') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GmapAddress from '@/components/elements/GmapAddress.vue'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  props: ['value', 'location'],
  components: {
    GmapAddress
  },
  data() {
    return {
      placesinfolabel: null,
      gmapvalue: null,
      shoplocation: [],
      showmap: false,
      googleapikey: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    }),
    distances() {
      return this.$store.state.distances
    },
    gmapapikey() {
      return this.$store.state.gmapapikey
    }
  },
  mounted() {
    this.gmapvalue = cloneDeep(this.location)
    if (this.gmapapikey) this.insertGoogleMapScript()
  },
  methods: {
    onCancel() {
      this.gmapvalue = cloneDeep(this.location)
      this.$emit('input', false)
    },
    onSelect() {
      this.$emit('changeLocation', {
        location: this.gmapvalue,
        placesinfolabel: this.placesinfolabel
      })
      this.$emit('input', false)
    },
    insertGoogleMapScript() {
      var vm = this
      vm.showmap = false
      let externalScript = document.createElement('script')
      externalScript.setAttribute(
        'src',
        `https://maps.googleapis.com/maps/api/js?key=${vm.gmapapikey}&language=th&libraries=places`
      )
      externalScript.async = true
      externalScript.defer = true
      externalScript.onload = () => {
        vm.showmap = true
      }
      document.head.appendChild(externalScript)
    },
    gmapLocation() {
      var vm = this
      var stringlatlng = this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      var service = new google.maps.DistanceMatrixService()
      var origins = [stringlatlng]
      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH'
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          vm.placesinfolabel = response.destinationAddresses[0]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SelectGmap.vue